// BodyButtons.jsx
import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

export default function Eat4Living() {
  const navigate = useNavigate()

  const [activeHover, setActiveHover] = useState(null);

  const buttonData = [
    {
      id: "recipes",
      label: "Recipes",
      color: "#FF6B6B", // warm red
      icon: (size = 20) => (
        // fork & knife icon
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
          <path d="M7 2v11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M11 2v7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 21c0-3.866 3.582-7 8-7s8 3.134 8 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
    },
    {
      id: "medical-tidbits",
      label: "Medical Tidbits",
      color: "#F39C12", // orange
      icon: (size = 20) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" fill="currentColor"/>
        </svg>
      ),
    },
    {
      id: "videos",
      label: "Videos",
      color: "#4D96FF", // blue
      icon: (size = 20) => (
        // play in rounded rectangle
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
          <rect x="2" y="5" width="20" height="14" rx="3" stroke="currentColor" strokeWidth="1.6" />
          <path d="M10 8.5v7l5-3.5-5-3.5z" fill="currentColor" />
        </svg>
      ),
    },
    {
      id: "mind",
      label: "Mind Health Articles",
      color: "#7C4DFF", // purple
      icon: (size = 20) => (
        // simple brain-like icon
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
          <path d="M12 3c2 0 3.5 1 4.5 2.5C17.8 6 19 7.4 19 9c0 1.7-1 2.5-1 4s.5 2.5 1 4c0 1.6-1.2 3-2.5 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 3c-2 0-3.5 1-4.5 2.5C6.2 6 5 7.4 5 9c0 1.7 1 2.5 1 4s-.5 2.5-1 4C5 19.6 6.2 21 7.5 21" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
    },
    {
      id: "education",
      label: "Education",
      color: "#2ECC71", // green
      icon: (size = 20) => (
        // graduation cap
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
          <path d="M12 2L2 7l10 5 10-5L12 2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" />
          <path d="M7 11v4a5 5 0 0 0 10 0v-4" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" />
          <path d="M12 7v10" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" />
        </svg>
      ),
    },
    {
      id: "affiliates",
      label: "Recommended Products",
      color: "#E91E63", // pinkish red
      icon: (size = 20) => (
        // shopping bag/cart
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" />
          <path d="M3 6h18" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" />
          <path d="M16 10a4 4 0 0 1-8 0" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" />
        </svg>
      ),
    },
  ];

  // container styles (inline)
  const containerStyle = {
    minHeight: "60vh", // body-only section (no header/footer)
    display: "flex",
    flexDirection: 'column',
    justifyContent: "center",
    alignItems: "center",
    padding: "28px",
    boxSizing: "border-box",
  };

  // vertical stack wrapper
  const stackStyle = {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    width: "100%",
    maxWidth: 420,
    alignItems: "stretch",
  };

  // base button style
  const baseButtonStyle = {
    display: "flex",
    alignItems: "center",
    border: "none",
    borderRadius: 10,
    padding: "12px 16px",
    fontSize: 16,
    fontWeight: 600,
    color: "#ffffff",
    cursor: "pointer",
    outline: "none",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    transition: "transform 160ms ease, box-shadow 160ms ease",
    textAlign: "left",
    width: "100%",
  };

  // icon wrapper style
  const iconWrapperStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 50,
    height: 50,
    borderRadius: 8,
    marginRight: 12,
    flexShrink: 0,
  };

  // label text style
  const labelStyle = {
    display: "inline-block",
    lineHeight: 1,
  };

  return (
    <main style={containerStyle} aria-label="Main body section">

      <div style={{ fontSize: 30, fontWeight: 'bold', marginBottom: 20 }}>
        Liviq
      </div>

      <div style={stackStyle}>
        {buttonData.map((btn, idx) => {
          const isHover = activeHover === idx;
          const computedButtonStyle = {
            ...baseButtonStyle,
            background: btn.color,
            transform: isHover ? "translateY(-3px)" : "translateY(0)",
            boxShadow: isHover
              ? "0 8px 22px rgba(0,0,0,0.18)"
              : baseButtonStyle.boxShadow,
          };

          // icon color contrast (use white icons)
          const iconColor = "#fff";

          return (
            <button
              key={btn.id}
              type="button"
              onMouseEnter={() => setActiveHover(idx)}
              onMouseLeave={() => setActiveHover(null)}
              onFocus={() => setActiveHover(idx)}
              onBlur={() => setActiveHover(null)}
              style={computedButtonStyle}
              aria-label={btn.label}
              onClick={() => {
                /* Placeholder click - replace with navigation/handler as needed */
                console.log(`${btn.label} clicked`);
                if (btn.id === 'mind') {
                  navigate('/mind-articles');
                }
                if (btn.id === 'education') {
                  navigate('/education');
                }
                if (btn.id === 'videos') {
                  navigate('/videos');
                }
                if (btn.id === 'recipes') {
                  navigate('/recipes');
                }
                if (btn.id === 'medical-tidbits') {
                  navigate('/medical-tidbits');
                }
                if (btn.id === 'affiliates') {
                  navigate('/affiliates');
                }
              }}>
              <span
                style={{
                  ...iconWrapperStyle,
                  background: "rgba(255,255,255,0.12)",
                  color: iconColor,
                }}
                aria-hidden="true"
              >
                {/* SVG icon uses currentColor */}
                <span style={{ display: "inline-flex", alignItems: "center" }}>
                  {btn.icon(30)}
                </span>
              </span>

              <span style={labelStyle}>{btn.label}</span>
            </button>
          );
        })}
      </div>
    </main>
  );
}
